// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__300CU","footertext":"Footer_footertext__m5scq"};